import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { memo } from "react";
import featureFlags from "../../constants/feature-flags.json";
export var FEATURE_FLAGS = featureFlags;
/**
 * FeatureToggle component accepts a single child component or a components tuple.
 * Components in a tuple should have "data-treatment" property with (on|off)
 * value.
 *
 * If single component is provided - it will be rendered based on the value of
 * the treatment (on|off) defined in Split.io console.
 *
 * If a tuple of components is provided - only the one with data-treatment "on"
 * will be rendered, while other is hidden (or ignored).
 *
 * If no configuration is found for given toggle, the component will not be
 * rendered.
 */ export var FeatureToggle = /*#__PURE__*/ memo(function FeatureToggle(param) {
    var children = param.children, flagName = param.flagName;
    return /*#__PURE__*/ _jsx(SplitTreatments, {
        names: Object.values(FEATURE_FLAGS),
        children: function(param) {
            var isReady = param.isReady, treatments = param.treatments;
            // In development mode all treatments are on. Fine for now.
            if (import.meta.env.MODE !== "production" || import.meta.env.VITE_MOCK) {
                treatments[flagName].treatment = "on";
            }
            if (isReady) {
                if (Array.isArray(children) && children.length > 1) {
                    return children.filter(function(child) {
                        return (child === null || child === void 0 ? void 0 : child.props["data-treatment"]) === treatments[flagName].treatment;
                    })[0];
                }
                return treatments[flagName].treatment === "on" ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: children
                }) : null;
            }
            return null;
        }
    });
});

//# sourceMappingURL=FeatureToggle.js.map